import React, { HTMLAttributes } from "react";

import AutocompleteSelectInput from "veneer/AutocompleteSelectInput";

import { Schema } from "cortex/ui/src/fleet/view/application/model";
import { sortByDisplayNameAsc } from "cortex/ui/src/util/sortByProp";

interface OptionalParamsSelectorProps {
  active?: string[];
  onSelect: (schema: Schema) => void;
  schemas?: Schema[];
}

interface SchemaOption {
  label: string;
  value: Schema;
}

const formatOption = (
  props: HTMLAttributes<HTMLLIElement>,
  { value: schema }: SchemaOption,
) => {
  const { display_name: displayName, description } = schema;

  return (
    <li {...props}>
      {displayName}
      {description && (
        <span className="font-smaller text-muted"> ({description})</span>
      )}
    </li>
  );
};

const OptionalParamsSelector = ({
  active = [],
  onSelect,
  schemas = [],
}: OptionalParamsSelectorProps) => {
  const options = schemas
    .filter((schema) => !schema.required)
    .filter((schema) => !active.includes(schema.name))
    .sort(sortByDisplayNameAsc)
    .map((schema) => ({ label: schema.display_name, value: schema }));

  const onChange = (_event: unknown, option: SchemaOption | null): void => {
    if (option) {
      onSelect(option.value);
    }
  };

  return (
    <AutocompleteSelectInput<SchemaOption>
      dataTestId="OptionalParams.SelectInput"
      getOptionLabel={(option) => option.label}
      inputProps={{
        placeholder: "Add optional parameter",
        size: "small",
      }}
      onChange={onChange}
      options={options}
      renderOption={formatOption}
      value={null}
    />
  );
};

export { OptionalParamsSelector };
